<lib-app-header
  [appTitle]="title"
  [appTitleShort]="title"
  [shadow]="false"
  [userName]="userName"
  [aisUrl]="aisLandingPage"
  [actions]="headerActions"
  [httpParams]="httpParams"
></lib-app-header>

<div class="container vh-100 d-flex align-items-center">
  <!-- <div class="h1 m-auto">hello world!</div> -->
  <div class="m-auto">
    <router-outlet></router-outlet>
  </div>
</div>

<lib-app-footer></lib-app-footer>
